export const capitalize = (text) => typeof text === 'string' && `${text.charAt(0).toUpperCase()}${text.slice(1).toLowerCase()}`

export const isEmptyOrNullOrUndefined = (value) => {
  if (typeof value === 'undefined' || value === null) {
    return true
  }
  return !!(typeof value === 'string' && value.trim().length === 0)
}
